export const fetch_all_categories = (categories, isSentParent = false) => {
  const all_categories = [];

  const processCategory = (category, parentNames = []) => {
    const currentHierarchy = [...parentNames, category.name];

    if (!category.sub_category?.length || isSentParent) {
      all_categories.push({
        name: currentHierarchy.join(' → '),
        id: category.id,
      });
    }

    if (category.sub_category?.length > 0) {
      category.sub_category.forEach(subCategory => {
        processCategory(subCategory, currentHierarchy);
      });
    }
  };

  categories.forEach(category => processCategory(category));

  return all_categories;
};

export const category_serialization = category => {
  let name = [];
  for (let index = 0; index < category.hierarchy.length; index++) {
    const element = category.hierarchy[index];
    name.push(element.name);
  }
  if (name.length == category.hierarchy.length) {
    return {label: name.join(' → '), value: category.id};
  }
};
